import React from "react";
import "../../components/Styles/Brand.css";

function Brand() {
  return <div className="brand-background"></div>;
}

export default Brand;
